import { type ProjectRequest, numbi } from "@msuite/katana";
import { FormControl, FormLabel, Input, Text, useUIContext } from "@msuite/picasso";
import { type FC, Fragment } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TbCurrencyEuro } from "react-icons/tb";
import { FormError, type ProjectRequestWonFormType } from "./schema";

/** Props Interface */
interface ProjectRequestWonFormProps {
	projectRequest: ProjectRequest | undefined;
}

export const ProjectRequestWonForm: FC<ProjectRequestWonFormProps> = ({ projectRequest }) => {
	/** Hooks */
	const { colors } = useUIContext();
	const methods = useFormContext<ProjectRequestWonFormType>();
	const contractSum = useWatch({ control: methods.control, name: "contractSum" });
	const difference = (contractSum ?? 0) - (projectRequest?.offerSum ?? 0);
	const isNotEqual = difference !== 0;
	const isNegativeDifference = difference < 0;
	const hintColor = isNegativeDifference ? colors.red : colors.emerald;

	/** Render */
	return (
		<FormControl>
			<FormLabel>Auftragssumme</FormLabel>
			<Input
				type="number"
				step={0.01}
				rightIcon={<TbCurrencyEuro />}
				{...methods.register("contractSum", { valueAsNumber: true })}
				placeholder={
					projectRequest?.offerSum ? numbi(projectRequest.offerSum).currency() : "Auftragssumme"
				}
			/>
			{contractSum.toString().length ? (
				<Fragment>
					{isNotEqual && (
						<Text
							mt={1}
							color={hintColor}
							fontSize="sm"
						>
							Differenz zur Angebotssumme: {numbi(difference ?? 0).currency()}
						</Text>
					)}
				</Fragment>
			) : null}
			<FormError name="contractSum" />
		</FormControl>
	);
};
